import { Component } from 'react';
import { withRouter } from 'react-router';
import { renderRoutes } from 'react-router-config';
import routes from './routes';
import { ServicesProvider } from '@wix/experts-common';

class ArenaRouter extends Component {
  componentDidMount() {
    this.context.services.fedopsLogger.appLoaded();
  }

  render() {
    return renderRoutes(routes);
  }
}

ArenaRouter.contextTypes = ServicesProvider.childContextTypes;

export default withRouter(ArenaRouter);
